// ============================================================
// chargePiece.js — le temps d'atelier d'une pièce et du devis, en heures
// et en jours, avec UN seul libellé. Pur : testé depuis
// `web/charge-piece.test.js`.
// ============================================================
import { chargeAtelier, minutesDuLot } from '@shared/gamme.js';
import { formatMesure, formatNumber } from '../../lib/format.js';

/** « 11,6 h · 1,4 jour d'atelier » — le même pour le devis et pour la pièce. */
export function libelleCharge(charge) {
  return `${formatMesure(charge.heures, 'h')} · ${formatNumber(charge.jours)} jour${charge.jours >= 2 ? 's' : ''} d’atelier`;
}

/**
 * Ce qu'affiche la vignette d'une pièce (Philippe, 6 octobre 2026) :
 * « — » tant qu'elle n'est pas chiffrée — un « 0 h » se lirait comme une
 * pièce qui ne coûte rien.
 */
export function chargeDeLaPiece(result) {
  const c = chargeAtelier(minutesDuLot(result?.detail?.work ?? {}));
  return result?.price_unit != null && c.minutes > 0 ? libelleCharge(c) : '—';
}
